import { NavLink, useNavigate } from "react-router-dom";
import styles from './index.module.css';
import LogoImg from '../../assets/images/brand/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const pages = [
    { name: "Home", path: "/" },
    { name: "All Vehicles", path: "/vehicles" },
    { name: "About Us", path: "/about-us" },
    { name: "How To Buy", path: "/how-to-buy" },
    { name: "Contact Us", path: "/contact-us" }
];

const Navbar = ({ toggleSidebar }) => {
    const navigate = useNavigate();

    const navigateHome = () => navigate('/')
    return (
        <>
            <div className={styles.topNavContainer}>
                <div className={styles.navBar}>
                    <div className={styles.topNavList}>
                        <div className={styles.detailText}><FontAwesomeIcon icon={faWhatsapp} />{" "}+94 77 775 7479</div>
                        <div className={styles.detailText}><FontAwesomeIcon icon={faEnvelope} />{" "}sales@mholdings.lk</div>
                    </div>
                </div>
            </div>
            <div className={styles.navContainer}>
                <div className={styles.navBar}>
                    <div className={styles.logoSec}>
                        <img src={LogoImg} alt="Logo" className={styles.logoImg} onClick={navigateHome} />
                    </div>
                    <div className={styles.pagesList}>
                        <ul className={styles.navList}>
                            {pages.map(({ name, path }) => (
                                <li key={name}>
                                    <NavLink to={path} className={({ isActive }) => isActive ? styles.active : ""}>
                                        {name}
                                    </NavLink>
                                </li>
                            ))}
                        </ul>
                        <div className={styles.barIcon} onClick={toggleSidebar}>
                            <FontAwesomeIcon icon={faBars} size="m" style={{ color: '#FFFFFF' }} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Navbar;